<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.333496 0.333252H3.66683V1.66659H1.66683V3.66659H0.333496V0.333252ZM6.3335 0.333252H9.66683V3.66659H8.3335V1.66659H6.3335V0.333252ZM8.3335 6.33325H9.66683V9.66659H6.3335V8.33325H8.3335V6.33325ZM3.66683 8.33325V9.66659H0.333496V6.33325H1.66683V8.33325H3.66683Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#2F7F91'
    },
    width: {
      type: String,
      default: '10'
    },
    height: {
      type: String,
      default: '10'
    }
  }
}
</script>
